import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {View} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {useIsDesktop} from '../../../../shared/hooks/useIsDesktop';
import {useTheme} from '../../../../shared/theme';
import {currentLocalitySelector} from '../../../../redux/selectors/localities';
import {useDimensions} from '../../../../shared/hooks/useDimensions';
import {images} from '../../../../assets/icons';
import {useSellersGeoMapStyles} from './SellersGeoMap.style';
import {Seller} from '../../../../shared/models/api/eCertificatesResponsePayload';
import {departmentSelector} from '../../../../redux/selectors/eCertificates';
import {getDepartmentById} from '../../../../redux/actions/eCertificates';
import {eCertificatesSlice} from '../../../../redux/reducers/eCertificates';
import {YaMap, Marker, ScrollViewMapProps} from '../../../../shared/components/yaMap';

interface MarkerPayload {
  departmentId: string;
  brand: string;
}

interface SellersGeoMapProps {
  mapProps?: ScrollViewMapProps;
  sellers?: Seller[] | null;
  setActiveTruIds: React.Dispatch<React.SetStateAction<number[] | undefined>>;
}

export function SellersGeoMap({sellers, setActiveTruIds, mapProps}: SellersGeoMapProps) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();
  const currentLocality = useSelector(currentLocalitySelector());
  const {height} = useDimensions();
  const department = useSelector(departmentSelector());
  const brand = useRef<string>();
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const mapHeight = height * 0.5;

  const styles = useSellersGeoMapStyles();

  const centerPoint = useMemo(() => currentLocality?.geolocation, [currentLocality]);

  const markers = useMemo(() => {
    const result: Marker<MarkerPayload>[] = [];

    sellers?.forEach((s) => {
      return s.departments.forEach((d, i) =>
        result.push({
          id: +d.latitude + +d.longitude + i,
          coordinates: [+d.latitude, +d.longitude],
          payload: {
            departmentId: d.departmentId.toString(),
            brand: s.brand,
          },
        }),
      );
    });

    return result;
  }, [sellers]);

  const handleClickMarker = useCallback((marker: Marker<MarkerPayload>) => {
    if (marker.payload) {
      brand.current = marker.payload.brand;
      dispatch(getDepartmentById(marker.payload.departmentId));
      setSidebarOpen(true);
    }
  }, []);

  const handleCloseInfo = useCallback(() => {
    setSidebarOpen(false);
    dispatch(eCertificatesSlice.actions.setDepartment(null));
  }, []);

  const mapDetails = useMemo(() => {
    return [
      {
        title: brand.current || '',
        info: [
          {
            text: department?.address ?? '',
            icon: <images.Location color={theme.color.primaryColor} />,
            show: !!department?.address,
          },
        ],
        show: !!department,
      },
    ];
  }, [department]);

  useEffect(() => {
    if (department) {
      setActiveTruIds(department.departmentTruAssignments.map((item) => item.truId));
    }
  }, [department]);

  return (
    <View style={styles.container}>
      {/*{!markers ||*/}
      {/*  (markers?.length === 0 && (*/}
      {/*    <View style={[styles.alertContainer]}>*/}
      {/*      <View style={[styles.overlay]} />*/}
      {/*      <View style={[styles.alertCard]}>*/}
      {/*        <Text style={[styles.alertText]}>*/}
      {/*          Чтобы узнать, в&nbsp;каких магазинах можно приобрести ТРУ, пожалуйста, кликните на&nbsp;ТРУ*/}
      {/*          в&nbsp;таблице выше.*/}
      {/*        </Text>*/}
      {/*      </View>*/}
      {/*    </View>*/}
      {/*  ))}*/}

      <View style={[styles.map, !isDesktop ? {height: mapHeight} : {}]}>
        <YaMap
          key={sellers?.length}
          markers={markers}
          centerPoint={centerPoint}
          onPressMarker={handleClickMarker}
          isDetailsVisible={isSidebarOpen}
          onCloseDetails={handleCloseInfo}
          details={mapDetails}
          {...mapProps}
        />
      </View>
    </View>
  );
}
